import React from "react";
import { Constants } from "../utils/constants";

const HToggle = ({ leftLabel, rightLabel, isToggled, onToggle, className = "" }) => {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <span className={`text-xs ${!isToggled ? "font-medium text-gray-900" : "text-gray-500"}`}>{leftLabel}</span>
      <div
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors cursor-pointer`}
        style={{
          backgroundColor: isToggled ? Constants.HOST_EXPERIENCE_BASE_COLOR : "#E5E7EB",
        }}
        onClick={onToggle}
      >
        <div
          className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
            isToggled ? "translate-x-5" : "translate-x-1"
          }`}
        />
      </div>
      <span className={`text-xs ${isToggled ? "font-medium text-gray-900" : "text-gray-500"}`}>{rightLabel}</span>
    </div>
  );
};

export default HToggle;
